import React, { useState, useEffect, useContext, useCallback, useRef } from 'react'
import { DataGrid,  GridToolbar } from '@mui/x-data-grid'
import { Button } from '@mui/material';
import './InterviewDetails.css'
import ScheduleInterviewUI from './ScheduleInterviewUI';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import EventIcon from '@mui/icons-material/Event';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import AudiotrackIcon from '@mui/icons-material/Audiotrack'; // <-- Added Audio Icon
import CheckIcon from '@mui/icons-material/Check';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Container } from '@mui/material';
import TextField from "@mui/material/TextField";
import { UserContext } from './UserContext';
import { useSearchParams } from 'react-router-dom';
import BulkDataUpload from './BulkDataUpload';
import Checkbox from '@mui/material/Checkbox';
import InterviewAudioPopup from './InterviewAudioPopup'; // <-- Imported Audio Popup Component

const Bookmarked = (props) => {
  const [searchParams] = useSearchParams();
  const [interview, setInterview] = useState([]);
  const [OpenShedule, setOpenScedule ]= React.useState();
  const [name, setName] = useState();
  const [mail, setMail] = useState();
  const [mobile, setMobile] = useState();
  const [jobId, setJobId] = React.useState();
  const [jobTitle, setJobTitle] = React.useState();
  const [applicantId,setApplicantId]= useState()
  const [companyName, setCompanyName] = useState();
  const [open, setOpen] = React.useState(false);
  const [Rounds, setRounds] = useState();
  const [InterViewerName, setInterViewerName]= useState("");
  const [InterViewDate, setInterViewDate] = React.useState(new Date());
  const [InterViewTime, setInterViewTime] = React.useState();
  const [interviewlocation, setInterviewlocation] = useState();
  const [selectedRow,setSelectedRow] = useState();
  const { user, setUser} = useContext(UserContext);

  // --- Audio States ---
  const [audioPopupOpen, setAudioPopupOpen] = useState(false);
  const [selectedAudioInterviewId, setSelectedAudioInterviewId] = useState(null);
  const [selectedName, setSelectedName] = useState('');
  const [selectedHRName, setSelectedHRName] = useState('');

  // --- Hardware Permissions States ---
  const [micAllowed, setMicAllowed] = useState(true);
  const micAllowedRef = useRef(true);

  const [filterModel, setFilterModel] = React.useState({
    items: [],
  });

  const style3 = {
    position: 'absolute',
    top: '50%',
    transform: 'translate(87%, -50%)',
    height: 489,
    width: 533,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 10,
  };

  // Audio Button Handler
  const handleOpenAudioPopup = useCallback(({ id, name, hrname }) => {
    setSelectedAudioInterviewId(id);
    setSelectedName(name);
    setSelectedHRName(hrname);
    setAudioPopupOpen(true);
  }, []);

  const cols = [
    {
      field:'action', headerName: '', width: 120, headerAlign:'center',
      renderCell: (params) => {
        return (
          <Box sx={{ display: 'flex' }}>
            <Button size='small' title="Schedule"  onClick={() => showApplicant(params.row)}>
              <PersonSearchIcon/>
            </Button>
            {params.row.hasAudio && (
              <Button size='small' title="View Audio Recordings" onClick={() => handleOpenAudioPopup(params.row)}>
                <AudiotrackIcon color="primary" />
              </Button>
            )}
          </Box>
        );
      },
    },  
    {field:'name', headerName: 'Name',width: 190 },
    {field:'createdbyname', headerName: 'Created By',width: 190,hide: true },
    {field:'mobile', headerName: 'Mobile No',width: 140},
    {field:'bookmarkcomment', headerName: 'Remarks',width: 450},
    {field:'hrname', headerName: 'HR Name',width: 190},
    { field: "area", headerName: "Location", width: 140 },
    {field:'jobtitle', headerName: 'Job Title',width: 200},
    {field:'companyname', headerName: 'Company Name',width: 200},
    {field:'interviewername', headerName: 'Interviewer Name',width: 190},
    {field:'interviewdate', headerName: 'Interview Date',width: 140},
  ];

  const getInterviews = () => {
    let apiURL = process.env.REACT_APP_API_URL + "/interview/bookmarked/" + user.name;
    let apiParams = {
        method:"GET", 
        headers:{
          authtoken: localStorage.getItem("loggedintoken")
        },
    };
    
    fetch(apiURL, apiParams)
    .then((res)=> (res.status===200 ? res.json() : res.text()))
    .then((repos)=> {
        if (repos.data) {
          setInterview(repos.data)
        } else props.showAlert(""+(repos.message || repos),"error");  
    }) 
    .catch((err) => props.showAlert((''+err),"error"));
  }

  useEffect(()=>{
    getInterviews()
  },[])
  
  // =========================================================
  // ✅ LIVE HARDWARE & PERMISSIONS MONITOR (Audio HR Only)
  // =========================================================
  const requestPermissionsManually = useCallback(async () => {
    if (Number(user?.accesstype) >= 3) return; // Admins don't need mic checks to view records

    let activeStream = null;
    let micPermissionStatus = null;

    const stopActiveStream = () => {
      if (activeStream) {
        activeStream.getTracks().forEach(t => {
          t.onmute = null;
          t.onunmute = null;
          t.onended = null;
          t.stop();
        });
        activeStream = null;
      }
    };

    const monitorHardware = async () => {
      try {
        stopActiveStream();
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true, video: false });
        activeStream = stream;
        const track = stream.getAudioTracks()[0];

        const updateState = () => {
          const isLiveAndUnmuted = track.readyState === 'live' && !track.muted;
          setMicAllowed(isLiveAndUnmuted);
          micAllowedRef.current = isLiveAndUnmuted;
        };

        updateState();

        track.onmute = updateState;
        track.onunmute = updateState;

        track.onended = () => {
          setMicAllowed(false);
          micAllowedRef.current = false;
          stopActiveStream();
        };

      } catch (err) {
        setMicAllowed(false);
        micAllowedRef.current = false;
      }
    };

    try {
      micPermissionStatus = await navigator.permissions.query({ name: "microphone" });

      if (micPermissionStatus.state === 'granted') {
        monitorHardware();
      } else {
        setMicAllowed(false);
        micAllowedRef.current = false;
        
        if (micPermissionStatus.state === 'prompt') {
          monitorHardware();
        }
      }

      micPermissionStatus.onchange = () => {
        if (micPermissionStatus.state === 'granted') {
          monitorHardware();
        } else {
          setMicAllowed(false);
          micAllowedRef.current = false;
          stopActiveStream();
        }
      };
    } catch (err) {
      monitorHardware();
    }

    const handleDeviceChange = () => {
      if (micPermissionStatus?.state === 'granted' || !micPermissionStatus) {
        monitorHardware();
      }
    };

    navigator.mediaDevices.addEventListener('devicechange', handleDeviceChange);

    return () => {
      navigator.mediaDevices.removeEventListener('devicechange', handleDeviceChange);
      if (micPermissionStatus) micPermissionStatus.onchange = null;
      stopActiveStream();
    };
  }, [user?.accesstype]);

  useEffect(() => {
    const cleanup = requestPermissionsManually();
    return () => {
      cleanup.then(cleanFn => {
        if (typeof cleanFn === 'function') cleanFn();
      });
    };
  }, [requestPermissionsManually]);


  // =========================================================
  // ✅ AUTO-CLOSE SCHEDULE INTERVIEW IF MIC IS LOST
  // =========================================================
  useEffect(() => {
    if (Number(user?.accesstype) < 3 && !micAllowed && OpenShedule) {
      setOpenScedule(false);
      props.showAlert("Interview closed because microphone access was revoked or muted.", "error");
    }
  }, [micAllowed, OpenShedule, props, user?.accesstype]);


  // =========================================================
  // ✅ DOUBLE CLICK LOGIC
  // =========================================================
  const scheduleinterview = (row) => {
    // Prevent HR users from opening if they lack mic access
    if (Number(user?.accesstype) < 3 && !micAllowedRef.current) {
      props.showAlert("Cannot open interview. Microphone is muted or unavailable.", "error");
      return; 
    }
    setSelectedRow(row)
    setOpenScedule(true);
  }
    
  const handleCloseView = () => setOpen(false)

  const showApplicant = (row) =>{
    window.isIntentionalRedirect = true;
    window.location.href="/applicants?applicantid="+row.applicantid;
  }

  const rowData = (interview)?.map((interview) => {
    let IntvwTime = interview.interviewtime ? ((interview.interviewtime).length < 6 ? (interview.interviewtime) : new Date((interview.interviewtime)).toTimeString().slice(0,5)) : new Date(new Date()).toTimeString().slice(0,5);

    return {
      id: interview?._id,  
      applicantid: interview?.applicantId, 
      jobid: interview?.jobId,  
      name: interview?.name,
      mobile: interview?.mobile,
      jobtitle: interview?.jobtitle,
      companyname: interview?.companyname,
      interviewername: interview?.interviewername,
      hrname: (interview.hrname && interview.hrname !== "undefined") ? interview.hrname : "",
      interviewdate: interview?.interviewdate && ( new Date(interview?.interviewdate)),
      interviewtime: IntvwTime,
      interviewlocation: interview?.location,
      area: interview?.location || "", 
      rounds: interview?.rounds,
      reference: interview?.reference,
      status: interview?.status,
      bookmark: (interview.bookmark && interview.bookmark !== "undefined") ? interview.bookmark : false,
      bookmarkcomment: (interview.bookmarkcomments && interview.bookmarkcomments !== "undefined") ? interview.bookmarkcomments : "",
      feedback: interview?.feedback,
      createdbyname: interview?.createdbyname,
      createdbyid: interview?.createdbyId,
      hasAudio: !!interview?.hasAudio, // <-- Added Audio Flag
      showAlert: props.showAlert,
    };
  });

  return (
    <div>
      <br/>
      <br/>
      <div style={{height:750,width: '100%'}}>
        <DataGrid 
          rows={rowData} 
          columns={cols}  
          components={{ Toolbar: GridToolbar }}
          filterModel={filterModel}
          onFilterModelChange={(newFilterModel) => setFilterModel(newFilterModel)}
          onRowDoubleClick={(e) => scheduleinterview(e.row)}
        />
      </div>

      <ScheduleInterviewUI 
        open={OpenShedule} 
        showAlert={props.showAlert} 
        interview={selectedRow} 
        refresh={() => getInterviews()} 
        close={() => setOpenScedule(false)} 
      />

      {/* Audio Render Component Mounted */}
      <InterviewAudioPopup
        open={audioPopupOpen}
        onClose={() => setAudioPopupOpen(false)}
        interviewId={selectedAudioInterviewId}
        intervieweeName={selectedName}
        hrName={selectedHRName}
        showAlert={props.showAlert}
      />

      {/* Warning Notification for HR Users if Mic is disconnected */}
      {Number(user?.accesstype) < 3 && !micAllowed && (
        <div style={{ color: 'yellow', backgroundColor: "red", textAlign: "center", padding: "8px", position: "fixed", bottom: 0, width: "100%", zIndex: 9999 }}>
          Please grant Microphone Permissions to process interviews!
          <Button 
            size="small" 
            variant="contained" 
            color="primary" 
            onClick={requestPermissionsManually} 
            sx={{ ml: 2, padding: "2px 10px", fontWeight: "bold" }}
          >
            Retry Access
          </Button>
        </div>
      )}
    </div>
  ) 
}

export default Bookmarked;